import { For, type JSX } from 'solid-js';
import { t } from '../i18n';
import { type KbPageRow, kbRetrievedLabel } from '../lib/kb';
import { day } from '../lib/time';

// Repo KB tab → the wiki index (arc 101 slice 07). Presenter: slug, when it was
// last written, and how often the agent has actually RETRIEVED it. Pure — the
// container owns the paging and which page is open.
//
// THE BODY IS NEVER RENDERED HERE even though `GET …/pages` carries `text` on
// every row. An index of full markdown bodies is not an index, and the panel
// point-reads the open page anyway; showing a slice of the body here would be a
// second, staler excerpt next to the search hit's real one.

export function KbPageIndex(props: {
  readonly rows: readonly KbPageRow[];
  readonly selected: string | null;
  readonly onOpen: (slug: string) => void;
}): JSX.Element {
  return (
    <ul class="repo-kb__list">
      <For each={props.rows}>
        {(row) => (
          <li class="row-list__row" data-slug={row.slug}>
            <button
              type="button"
              class="repo-kb__entry"
              aria-current={props.selected === row.slug ? 'true' : undefined}
              onClick={() => props.onOpen(row.slug)}
            >
              <code class="repo-kb__slug">{row.slug}</code>
              <span class="repo-kb__meta">
                {t('repo_kb.updated', { when: day(row.ts) })}
                {' · '}
                {kbRetrievedLabel(row.used_count)}
              </span>
            </button>
          </li>
        )}
      </For>
    </ul>
  );
}
